import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "height": "80%"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "时间"), /*#__PURE__*/_createElementVNode("th", null, "主队"), /*#__PURE__*/_createElementVNode("th", null, "盘口"), /*#__PURE__*/_createElementVNode("th", null, "客队")])], -1);
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "时间"), /*#__PURE__*/_createElementVNode("th", null, "胜"), /*#__PURE__*/_createElementVNode("th", null, "平"), /*#__PURE__*/_createElementVNode("th", null, "负")])], -1);
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "时间"), /*#__PURE__*/_createElementVNode("th", null, "大球"), /*#__PURE__*/_createElementVNode("th", null, "盘口"), /*#__PURE__*/_createElementVNode("th", null, "小球")])], -1);
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
export default {
  __name: 'HandicapView',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const isListVisible = ref(false);
    const active = ref(0);
    const companyActive = ref(0);
    const oddsList = ref([[], [], []]);
    const loading = ref(false);
    const id = ref("");
    const divStyle1 = ref('display: block;'); // 初始样式设置div为可见
    const divStyle2 = ref('display: none'); // 初始样式设置div为可见
    const divStyle3 = ref('display: none'); // 初始样式设置div为可见
    // 显示弹出框
    const show = matchId => {
      isListVisible.value = true;
      id.value = matchId;
      active.value = 0;
      companyActive.value = 0;
      oddsList.value = [[], [], []];
      getOdds(matchId, 3);
    };

    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };
    const change = value => {
      if (value == 0) {
        getOdds(id.value, 3);
      } else if (value == 1) {
        getOdds(id.value, 2);
      } else if (value == 2) {
        getOdds(id.value, 7);
      } else if (value == 3) {
        getOdds(id.value, 9);
      } else if (value == 4) {
        getOdds(id.value, 136);
      } else {
        getOdds(id.value, 3);
      }
    };
    const listChange = value => {
      if (value == 0) {
        divStyle1.value = 'display: block;';
        divStyle2.value = 'display: none;';
        divStyle3.value = 'display: none;';
      } else if (value == 1) {
        divStyle2.value = 'display: block;';
        divStyle1.value = 'display: none;';
        divStyle3.value = 'display: none;';
      } else {
        divStyle3.value = 'display: block;';
        divStyle2.value = 'display: none;';
        divStyle1.value = 'display: none;';
      }
    };
    const getHand = val => {
      let num = val;
      if (val == '平手') {
        num = '0';
      } else if (val == '平手/半球') {
        num = '-0.25';
      } else if (val == '半球') {
        num = -0.5;
      } else if (val == '半球/一球') {
        num = '-0.75';
      } else if (val == '一球') {
        num = '-1';
      } else if (val == '一球/球半') {
        num = '-1.25';
      } else if (val == '球半') {
        num = '-1.5';
      } else if (val == '球半/两球') {
        num = '-1.75';
      } else if (val == '两球') {
        num = '-2';
      } else if (val == '两球/两球半') {
        num = '-2.25';
      } else if (val == '两球半') {
        num = '-2.5';
      } else if (val == '两球半/三球') {
        num = '-2.75';
      } else if (val == '三球') {
        num = '-3';
      } else if (val == '三球/三球半') {
        num = '-3.25';
      } else if (val == '三球半') {
        num = '-3.5';
      } else if (val == '三球半/四球') {
        num = '-3.75';
      } else if (val == '四球') {
        num = '-4';
      } else if (val == '四球/四球半') {
        num = '-4.25';
      } else if (val == '四球半') {
        num = '-4.5';
      } else if (val == '四球半/五球') {
        num = '-4.75';
      } else if (val == '五球') {
        num = '-5';
      } else if (val == '受让平手') {
        num = '0';
      } else if (val == '受让平手/半球') {
        num = '0.25';
      } else if (val == '受让半球') {
        num = 0.5;
      } else if (val == '受让半球/一球') {
        num = '0.75';
      } else if (val == '受让一球') {
        num = '1';
      } else if (val == '受让一球/球半') {
        num = '1.25';
      } else if (val == '受让球半') {
        num = '1.5';
      } else if (val == '受让球半/两球') {
        num = '1.75';
      } else if (val == '受让两球') {
        num = '2';
      } else if (val == '受让两球/两球半') {
        num = '2.25';
      } else if (val == '受让两球半') {
        num = '2.5';
      } else if (val == '受让两球半/三球') {
        num = '2.75';
      } else if (val == '受让三球') {
        num = '3';
      } else if (val == '受让三球/三球半') {
        num = '3.25';
      } else if (val == '受让三球半') {
        num = '3.5';
      } else if (val == '受让三球半/四球') {
        num = '3.75';
      } else if (val == '受让四球') {
        num = '4';
      } else if (val == '受让四球/四球半') {
        num = '4.25';
      } else if (val == '受让四球半') {
        num = '4.5';
      } else if (val == '受让四球半/五球') {
        num = '4.75';
      } else if (val == '受让五球') {
        num = '5';
      }
      return num;
    };
    const styleColor = (val1, val2) => {
      if (Number(val1) > Number(val2)) {
        return "color:red";
      } else if (Number(val1) < Number(val2)) {
        return "color:green";
      } else {
        return "";
      }
    };
    const getOdds = async (matchId, compandId) => {
      loading.value = true;
      let url = 'https://tuhaojie.asia/api-foot/matchGoalWater/selectCompanyOdds?id=' + matchId + '&company=' + compandId;
      const response = await axios.get(url);
      const data = response.data;
      oddsList.value = data;
      loading.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_tab = _resolveComponent("var-tab");
      const _component_var_tabs = _resolveComponent("var-tabs");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_var_table = _resolveComponent("var-table");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 10px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_var_row, null, {
          default: _withCtx(() => [_createVNode(_component_var_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_var_tabs, {
              class: "tabs-example-vertical",
              "layout-direction": "vertical",
              active: companyActive.value,
              "onUpdate:active": _cache[0] || (_cache[0] = $event => companyActive.value = $event),
              onChange: change
            }, {
              default: _withCtx(() => [_createVNode(_component_var_tab, null, {
                default: _withCtx(() => [_createTextVNode("皇冠")]),
                _: 1
              }), _createVNode(_component_var_tab, null, {
                default: _withCtx(() => [_createTextVNode("365")]),
                _: 1
              }), _createVNode(_component_var_tab, null, {
                default: _withCtx(() => [_createTextVNode("澳门")]),
                _: 1
              }), _createVNode(_component_var_tab, null, {
                default: _withCtx(() => [_createTextVNode("威廉希尔")]),
                _: 1
              }), _createVNode(_component_var_tab, null, {
                default: _withCtx(() => [_createTextVNode("香港马会")]),
                _: 1
              })]),
              _: 1
            }, 8, ["active"])])]),
            _: 1
          }), _createVNode(_component_var_col, {
            span: 18
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_var_row, null, {
              default: _withCtx(() => [_createVNode(_component_var_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_var_tabs, {
                  active: active.value,
                  "onUpdate:active": _cache[1] || (_cache[1] = $event => active.value = $event),
                  onChange: listChange
                }, {
                  default: _withCtx(() => [_createVNode(_component_var_tab, null, {
                    default: _withCtx(() => [_createTextVNode("亚盘")]),
                    _: 1
                  }), _createVNode(_component_var_tab, null, {
                    default: _withCtx(() => [_createTextVNode("欧盘")]),
                    _: 1
                  }), _createVNode(_component_var_tab, null, {
                    default: _withCtx(() => [_createTextVNode("大小")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["active"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_var_row, null, {
              default: _withCtx(() => [_createVNode(_component_var_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_var_loading, {
                  description: "加载中",
                  loading: loading.value
                }, {
                  default: _withCtx(() => [_createElementVNode("div", {
                    style: _normalizeStyle(divStyle1.value)
                  }, [_createVNode(_component_var_table, {
                    "scroller-height": "600"
                  }, {
                    default: _withCtx(() => [_hoisted_2, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oddsList.value[0], (item, index) => {
                      return _openBlock(), _createElementBlock(_Fragment, {
                        key: index
                      }, [index == oddsList.value[0].length - 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", null, _toDisplayString(item.value2), 1), _createElementVNode("td", null, _toDisplayString(getHand(item.value3)), 1), _createElementVNode("td", null, _toDisplayString(item.value4), 1)])) : (_openBlock(), _createElementBlock("tr", _hoisted_4, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value2, oddsList.value[0][index + 1].value2))
                      }, _toDisplayString(item.value2), 5), _createElementVNode("td", null, _toDisplayString(getHand(item.value3)), 1), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value4, oddsList.value[0][index + 1].value4))
                      }, _toDisplayString(item.value4), 5)]))], 64);
                    }), 128))])]),
                    _: 1
                  })], 4), _createElementVNode("div", {
                    style: _normalizeStyle(divStyle2.value)
                  }, [_createVNode(_component_var_table, {
                    "scroller-height": "600"
                  }, {
                    default: _withCtx(() => [_hoisted_5, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oddsList.value[1], (item, index) => {
                      return _openBlock(), _createElementBlock(_Fragment, {
                        key: index
                      }, [index == oddsList.value[1].length - 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", null, _toDisplayString(item.value2), 1), _createElementVNode("td", null, _toDisplayString(item.value3), 1), _createElementVNode("td", null, _toDisplayString(item.value4), 1)])) : (_openBlock(), _createElementBlock("tr", _hoisted_7, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value2, oddsList.value[1][index + 1].value2))
                      }, _toDisplayString(item.value2), 5), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value3, oddsList.value[1][index + 1].value3))
                      }, _toDisplayString(item.value3), 5), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value4, oddsList.value[1][index + 1].value4))
                      }, _toDisplayString(item.value4), 5)]))], 64);
                    }), 128))])]),
                    _: 1
                  })], 4), _createElementVNode("div", {
                    style: _normalizeStyle(divStyle3.value)
                  }, [_createVNode(_component_var_table, {
                    "scroller-height": "600"
                  }, {
                    default: _withCtx(() => [_hoisted_8, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oddsList.value[2], (item, index) => {
                      return _openBlock(), _createElementBlock(_Fragment, {
                        key: index
                      }, [index == oddsList.value[2].length - 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", null, _toDisplayString(item.value2), 1), _createElementVNode("td", null, _toDisplayString(item.value3.replace('球', "")), 1), _createElementVNode("td", null, _toDisplayString(item.value4), 1)])) : (_openBlock(), _createElementBlock("tr", _hoisted_10, [_createElementVNode("td", null, _toDisplayString(item.value1.split('-')[1]) + "-" + _toDisplayString(item.value1.split('-')[2]), 1), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value2, oddsList.value[2][index + 1].value2))
                      }, _toDisplayString(item.value2), 5), _createElementVNode("td", null, _toDisplayString(item.value3.replace('球', "")), 1), _createElementVNode("td", {
                        style: _normalizeStyle(styleColor(item.value4, oddsList.value[2][index + 1].value4))
                      }, _toDisplayString(item.value4), 5)]))], 64);
                    }), 128))])]),
                    _: 1
                  })], 4)]),
                  _: 1
                }, 8, ["loading"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};